import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ErrorIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth="1.5" {...props}>
            <g fill="none">
                <path
                    d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333Z"
                    stroke="currentColor"
                    strokeWidth="inherit"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 7.5L7.5 12.5"
                    stroke="currentColor"
                    strokeWidth="inherit"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 7.5L12.5 12.5"
                    stroke="currentColor"
                    strokeWidth="inherit"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </SvgIcon>
    );
};
